/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "../api";

export type Notification = {
  id: string;
  tutorId: number;
  titulo: string;
  descricao: string;
  createdAt: string;
  updatedAt: string;
  read: boolean;
};

export interface PetInfo {
  nome: string;
  especie: string;
  genero: string;
}

export interface AgendamentoConsulta {
  pet: PetInfo;
}

export interface Pergunta {
  id: string;
  pergunta: string;
  tipo: "ESCALA" | "TEXTO";
}

export interface PesquisaPergunta {
  ordem: number;
  pergunta: Pergunta;
}

export interface Pesquisa {
  id: string;
  agendamento_consulta: AgendamentoConsulta;
  perguntas: PesquisaPergunta[];
}

export interface RespostaPesquisa {
  perguntaId: string;
  resposta: string | number;
}

export interface RespostasEnvio {
  pesquisaId: string;
  respostas: RespostaPesquisa[];
}

export class NotificationService {
  async getNotifications(): Promise<Notification[]> {
    try {
      const response = await api.get("/notification");
      return response.data;
    } catch (error: any) {
      console.log("error", error.response?.data);
      
      throw {
        message: error.response?.data.error || "Erro ao buscar notificações",
      };
    }
  }

  async markAsRead(id: string): Promise<Notification> {
    try {
      const response = await api.get(`/notification/read/${id}`);
      return response.data;
    } catch (error: any) {
      console.log("error", error.response?.data);
      
      throw {
        message: error.response?.data.error || "Erro ao marcar notificação como lida",
      };
    }
  }

  async pesquisaSatisfacao(): Promise<Pesquisa[]> {
    try {
      const response = await api.get("/agendamentos/pesquisa-satisfacao/listar");
      
      return response.data;
    } catch (error: any) {
      console.log("error", error.response?.data);
      
      throw {
        message: error.response?.data.error || "Erro ao buscar pesquisa de satisfação",
      };
    }
  }

  async enviarPesquisaSatisfacao(dados: RespostasEnvio): Promise<any> {
    try {
      const response = await api.post("/agendamentos/pesquisa-satisfacao/responder", dados);

      return response.data;
    } catch (error: any) {
      console.log({
        error: error.response?.data,
        message: "Erro ao enviar respostas da pesquisa",
      });
      
      throw {
        message: error.response?.data.error || "Erro ao enviar respostas da pesquisa",
      };
    }
  }

  

  async recusarPesquisaSatisfacao(id:string): Promise<any> {
    try {
      const response = await api.post("/agendamentos/pesquisa-satisfacao/recusar",{pesquisaId:id});
      return response.data;
    } catch (error: any) {
      console.log("error", error.response?.data);
      
      throw {
        message: error.response?.data.error || "Erro ao recusar pesquisa",
      };
    }
  }
}